export enum ButtonTypeEnum {
    SUBMIT,
    CANCEL
}